// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"32a5bb12","453":"6d4a2d1d","455":"abb7e477"}[chunkId] + ".chunk.js";
};